module.exports = __webpack_public_path__ + "static/media/31da4b04-f98a-4b5f-b545-a31d26da99e5.b379869f.woff2";